var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"accent","dark":"","app":""}},[_c('div',[_c('h3',[_vm._v("Ver. 2.0.0")])]),_c('v-spacer'),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear())+" B.P.WORKS inc.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }